import * as React from 'react';
import { useState} from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from "../../config.js";
// import { TextField } from '@mui/material';
// import AdapterDateFns from '@mui/x-date-pickers/AdapterDateFns';
// import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { ExportToExcel } from './ExportToExcel';
import UserForm from '../FormLayouts/fb-elements/UserForm';

import {
  Card,
  CardContent,
  Divider,
  Box,
  Typography,
  TextField,
  MenuItem,
  Select,
  Button,
  InputLabel
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const headCells=[[
  {
    id: 'Edit',
    numeric: false,
    disablePadding: false,
    label: 'Edit',
  },
  {
    id: 'User ID',
    numeric: false,
    disablePadding: true,
    label: 'User ID',
  },
  {
    id: 'User Name',
    numeric: true,
    disablePadding: false,
    label: 'User Name',
  },
  {
    id: 'Email ID',
    numeric: true,
    disablePadding: false,
    label: 'Email ID',
  },
  {
    id: 'Phone number',
    numeric: true,
    disablePadding: false,
    label: 'Phone number',
  },
  {
    id: 'Department',
    numeric: true,
    disablePadding: false,
    label: 'Department',
  },
  {
    id: 'Designation',
    numeric: true,
    disablePadding: false,
    label: 'Designation',
  },
  {
    id: 'Password',
    numeric: true,
    disablePadding: false,
    label: 'Password',
  },
],
[
  {
    id: 'Edit',
    numeric: false,
    disablePadding: false,
    label: 'Edit',
  },
  {
    id: 'complaintType',
    numeric: false,
    disablePadding: false,
    label: 'Complaint Type',
  },
  {
    id: 'Department',
    numeric: false,
    disablePadding: false,
    label: 'Department',
  },
],
[
  {
    id: 'Edit',
    numeric: false,
    disablePadding: false,
    label: 'Edit',
  },
  {
    id: 'ComplaintType',
    numeric: false,
    disablePadding: false,
    label: 'Complaint Type',
  },
  {
    id: 'SubComplaintType',
    numeric: false,
    disablePadding: false,
    label: 'Sub ComplaintType',
  },
],
[
  {
    id: 'Edit',
    numeric: false,
    disablePadding: false,
    label: 'Edit',
  },
  {
    id: 'Department',
    numeric: false,
    disablePadding: false,
    label: 'Department',
  },
]
]

function EnhancedTableHead(props) {
  const { onSelectAllClick, numSelected, rowCount,value } =
    props;

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all Users',
            }}
          />
        </TableCell>
        {headCells[value-1].map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
          >
              {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {

  const { numSelected,selected,onAddUser} = props;
  const navigate = useNavigate();

  // Function to handle the click event
  

  const deleteUser = async() =>{
        const response = await fetch (`${config.BASE_URL_IP}/wob/delete-user`,{
            method: 'DELETE',
            headers: {'Content-Type': 'application/json',},
            body: JSON.stringify({users:selected}),
        })

        // const jsonData = response.json();
        console.log(response);
  }

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Table
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton onClick={()=>{deleteUser()}}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Add User">
          <IconButton onClick={()=>{onAddUser()}}>
            <PersonAddAltIcon/>
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onAddUser: PropTypes.func.isRequired,
};

const AdminTable = ({value,changeSelect}) => {

  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [rows,setRows]=React.useState([{}]);
  const [data, setData] = useState([]);
  const fileName = "myfile"; // here enter filename for your excel file
  const [showUserForm, setShowUserForm] = useState(false);
  const [departments, setdepartments] = useState([]);
  const [complaintTypes, setcomplaintTypes] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editRowId, setEditRowId] = useState(null);
  const [editableData, setEditableData] = useState({});
  
  const handleEditClick = (id,userid) => {
    setIsEditing(true);
    setEditRowId(id);
    if (value===1){
      setEditableData(rows.find((row) => row.user_id === userid));
    }
    if (value===2){
      setEditableData(rows.find((row) => row.complaint_type_id === userid));
    }
    if (value===3){
      setEditableData(rows.find((row) => row.sub_complaint_type_id === userid));
    }
    if (value===4){
      setEditableData(rows.find((row) => row.department_id === userid));
    }
  };

  const handleSaveClick = async(id) => {
    if(value==1){
      try {
        const body = editableData;
        const response = await fetch(`${config.BASE_URL_IP}/wob/update-user/${id}`,
      {
      method:'PATCH',
      headers:{ 'Content-Type':'Application/json'},
      body: JSON.stringify(body)
      })
      setIsEditing(false);
      } catch (err) {
        console.error(err.message);
      }
    }
    if(value==2)
      {
        console.log(editableData);
        try {
          const body = editableData;
          const response = await fetch(`${config.BASE_URL_IP}/wob/update-complaintType/${id}`,
        {
        method:'PATCH',
        headers:{ 'Content-Type':'Application/json'},
        body: JSON.stringify(body)
        })
        setIsEditing(false);
        } catch (err) {
          console.error(err.message);
        }
      }
      if(value==3)
        {
          console.log(editableData);
          try {
            const body = editableData;
            const response = await fetch(`${config.BASE_URL_IP}/wob/update-complaintsubType/${id}`,
          {
          method:'PATCH',
          headers:{ 'Content-Type':'Application/json'},
          body: JSON.stringify(body)
          })
          setIsEditing(false);
          } catch (err) {
            console.error(err.message);
          }
        }
        if(value==4)
          {
            console.log(editableData);
            try {
              const body = editableData;
              const response = await fetch(`${config.BASE_URL_IP}/wob/update-departments/${id}`,
            {
            method:'PATCH',
            headers:{ 'Content-Type':'Application/json'},
            body: JSON.stringify(body)
            })
            setIsEditing(false);
            } catch (err) {
              console.error(err.message);
            }
          }
  };

  const  handlediscardClick = () => {
    setIsEditing(false);
  };

  const getUsers = async () =>{

    const response = await fetch(`${config.BASE_URL_IP}/wob/get_all_users`,
    {
    method:'GET',
    headers:{ 'Content-Type':'Application/json'}
    })
    
    const jsonData = await response.json();
     
    setRows(jsonData);
    setData(jsonData);
  }

  const getComplainttypes = async () =>{

    const response = await fetch(`${config.BASE_URL_IP}/wob/get_all_complaint_types`,
    {
    method:'GET',
    headers:{ 'Content-Type':'Application/json'}
    })
    
    const jsonData = await response.json();
    if(value===2){
      setRows(jsonData);
    }
    setcomplaintTypes(jsonData);
  }

  const getsubComplainttypes = async () =>{

    const response = await fetch(`${config.BASE_URL_IP}/wob/get_all_sub_complaint_types`,
    {
    method:'GET',
    headers:{ 'Content-Type':'Application/json'}
    })
    
    const jsonData = await response.json();
    setRows(jsonData);
  }

  const getdepartments = async () => {
    try {
      const response = await fetch(`${config.BASE_URL_IP}/wob/getdepartments`,
      {
        headers:{"Content-Type":"application/json"},
        method:"GET"
      }
      );
      const jsonData = await response.json();
      setdepartments(jsonData);
      if(value===4){
      setRows(jsonData);
      }
    } catch (err) {
      console.error(err.message)
    } 
  }

  // const getInProgressComplaints = async () => {
  //   try {
  //     const userId = 'IT01'
  //     const response = await fetch(`${config.BASE_URL_IP}/wob/Inprogresscomplaints/${userId}`, {
  //       method: "GET",
  //       headers: { "Content-Type": "application/json" },
  //     });
  //     const jsonData = await response.json();
  //     console.log(jsonData);
  //     jsonData.sort((a, b) => {
  //       let da = new Date(a.complaint_raise_date),
  //         db = new Date(b.complaint_raise_date);
  //       return db - da;
  //     });
  //     setData(jsonData);
  //   } catch (err) {
  //     console.error(err.message);
  //   }
  // };

  useEffect(()=>{
    if(value===1){
      getUsers();
      getdepartments();
    }
    if(value===2){
      getComplainttypes();
      getdepartments();
    }
    if(value===3)
      {
        getsubComplainttypes();
        getComplainttypes();
      }
    if(value===4)
      {
        getdepartments();
      }
  },[rows])

  const handleAddUser = () => {
    setShowUserForm(!showUserForm); // Show the UserForm component
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.user_id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    if (!event.target.closest('.editButton')) {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
    //   stableSort(rows).slice(
    //     page * rowsPerPage,
    //     page * rowsPerPage + rowsPerPage,
    //   ),
      rows.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
  );
  
  const handleChange = (event, id) => {
    const { name, value } = event.target;
    console.log(editableData);
    setEditableData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  if (showUserForm) {
    return <UserForm onAddUser={handleAddUser} value={value}/>;
  }
  return (
    <>
    {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
    <DesktopDatePicker
      label="From Date"
      inputFormat="MM/dd/yyyy"
      value={selectedFromDate}
      onChange={handleFromDateChange}
      renderInput={(params) => <TextField {...params} />}
    />
    <DesktopDatePicker
      label="To Date"
      inputFormat="MM/dd/yyyy"
      value={selectedToDate}
      onChange={handleToDateChange}
      renderInput={(params) => <TextField {...params} />}
    />
  </LocalizationProvider> */}
    <Box sx={{ width: '100%' }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={()=>changeSelect(false)}
        variant="contained"
        sx={{ mb: 2 }}
      >
        Back
      </Button>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <EnhancedTableToolbar numSelected={selected.length} selected={selected} onAddUser={handleAddUser} />
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              onSelectAllClick={handleSelectAllClick}
              rowCount={rows.length}
              value={value} 
            />
            <TableBody>
              {visibleRows.map((row, index) => {
                const isItemSelected = isSelected(row.complaint_type_id);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    onClick={(event) => handleClick(event,row.complaint_type_id )}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        checked={isItemSelected}
                        inputProps={{
                          'aria-labelledby': labelId,
                        }}
                      />
                    </TableCell>
                    <TableCell>
          <div className='editButton'>
          {value===1 && (
          <>
          <IconButton onClick={()=>{handleEditClick(index,row.user_id);console.log(visibleRows)}}>
            <span className="material-icons outlined" style={{ fontSize: '24px', color: 'black' }}>edit</span>
          </IconButton>
        { isEditing && editRowId === index  && (
          <>
           <IconButton className="saveButton" onClick={()=>{handleSaveClick(row.user_id)}}>
            <span className="material-icons outlined" style={{ fontSize: '24px', color: '#0BDA2E' }}>done</span>
          </IconButton>
          <IconButton className="discardButton" onClick={handlediscardClick}>
          <span className="material-icons outlined" style={{ fontSize: '24px', color: '#F41010' }}>close</span>
          </IconButton>
          </>
        )}
          </>
              )}
          {value===2 && (
          <>
          <IconButton onClick={()=>{handleEditClick(index,row.complaint_type_id);console.log(visibleRows)}}>
            <span className="material-icons outlined" style={{ fontSize: '24px', color: 'black' }}>edit</span>
          </IconButton>
        { isEditing && editRowId === index  && (
          <>
           <IconButton className="saveButton" onClick={()=>{handleSaveClick(row.complaint_type_id)}}>
            <span className="material-icons outlined" style={{ fontSize: '24px', color: '#0BDA2E' }}>done</span>
          </IconButton>
          <IconButton className="discardButton" onClick={handlediscardClick}>
          <span className="material-icons outlined" style={{ fontSize: '24px', color: '#F41010' }}>close</span>
          </IconButton>
          </>
        )}
          </>
              )}
           {value===3 && (
          <>
          <IconButton onClick={()=>{handleEditClick(index,row.sub_complaint_type_id);console.log(visibleRows)}}>
            <span className="material-icons outlined" style={{ fontSize: '24px', color: 'black' }}>edit</span>
          </IconButton>
        { isEditing && editRowId === index  && (
          <>
           <IconButton className="saveButton" onClick={()=>{handleSaveClick(row.sub_complaint_type_id)}}>
            <span className="material-icons outlined" style={{ fontSize: '24px', color: '#0BDA2E' }}>done</span>
          </IconButton>
          <IconButton className="discardButton" onClick={handlediscardClick}>
          <span className="material-icons outlined" style={{ fontSize: '24px', color: '#F41010' }}>close</span>
          </IconButton>
          </>
        )}
          </>
              )}
              {value===4 && (
          <>
          <IconButton onClick={()=>{handleEditClick(index,row.department_id);console.log(visibleRows)}}>
            <span className="material-icons outlined" style={{ fontSize: '24px', color: 'black' }}>edit</span>
          </IconButton>
        { isEditing && editRowId === index  && (
          <>
           <IconButton className="saveButton" onClick={()=>{handleSaveClick(row.department_id)}}>
            <span className="material-icons outlined" style={{ fontSize: '24px', color: '#0BDA2E' }}>done</span>
          </IconButton>
          <IconButton className="discardButton" onClick={handlediscardClick}>
          <span className="material-icons outlined" style={{ fontSize: '24px', color: '#F41010' }}>close</span>
          </IconButton>
          </>
        )}
          </>
              )}
          </div>
      </TableCell>
                   {value===1 && (
                   <>
                   <TableCell>
                    {isEditing && editRowId === index ? (
            <TextField
              name="user_id"
              id='user_id'
              value={editableData.user_id}
              onChange={(e) => {handleChange(e, row.user_id);console.log(editableData)}}
            />
        ) : (
          row.user_id
        )}
                    </TableCell>
                    
                    <TableCell align="right">
                    {isEditing && editRowId === index ? (
            <TextField
              name="user_name"
              id='user_name'
              value={editableData.user_name}
              onChange={(e) => handleChange(e, row.user_id)}
            />
          ) : (
            row.user_name
          )}
                    </TableCell>
                    
                    <TableCell align="right">
                      {isEditing && editRowId === index ? (
            <TextField
              name="email_id"
              id='email_id'
              value={editableData.email_id}
              onChange={(e) => handleChange(e, row.user_id)}
            />
          ) : (
            row.email_id
          )}
          </TableCell>

                    <TableCell align="right">
                    {isEditing && editRowId === index  ? (
            <TextField
              name="phone_number"
              id='phone_number'
              value={editableData.phone_number}
              onChange={(e) => handleChange(e, row.user_id)}
            />
          ) : (
            row.phone_number
          )}
                    </TableCell>
                    {/* <TableCell align="right">{departments.find((dept)=>dept.department_id === row.department_id)?.department}</TableCell>
                     */}
                     
                     <TableCell align="right">
                      {isEditing && editRowId === index ? (
                        <>       
                        <Select
                          native
                          defaultValue={30}
                          name="department_id"
                          id="department-select"
                          sx={{width:200}}
                          value={editableData.department_id}
                          onChange={(e) => handleChange(e, row.user_id)} // Specify 'designation' for clarity
                          label="department_id" // Optional label for accessibility
                        >
                                <option value="" disabled>
                    <em>Departments</em>
                  </option>
                  {departments.map(dept => (
                    <option key={dept.department_id} value={dept.department_id}>
                      {dept.department}
                    </option>
                  ))}
                        </Select>
                        </>
                      ) : (
                        departments.find((dept)=>dept.department_id === row.department_id)?.department
                      )}
                    </TableCell>
                    
                    <TableCell align="right">
                    {isEditing && editRowId === index ? (
            <TextField
              name="designation"
              id="designation"
              value={editableData.designation}
              onChange={(e) => handleChange(e, row.user_id)}
            />
          ) : (
            row.designation
          )}
                    </TableCell>
                    
                    <TableCell align="right">
                    {isEditing && editRowId === index ? (
            <TextField
              name="pass_word"
              id='pass_word'
              value={editableData.pass_word}
              onChange={(e) => handleChange(e, row.user_id)}
            />
          ) : (
            row.pass_word
          )}
                    </TableCell>
                   </>
                   )}

                   {value ===2 && (
                    <>
                    <TableCell align="middle">
                    {isEditing && editRowId === index ? (
            <TextField
              name="complaint_type"
              id="complaint_type"
              sx={{width:500}}
              value={editableData.complaint_type}
              onChange={(e) => handleChange(e, row.complaint_type)}
            />
          ) : (
            row.complaint_type
          )}
          </TableCell>
          
          <TableCell align="middle">
                      {isEditing && editRowId === index ? (
                        <>       
                        <Select
                          native
                          defaultValue={30}
                          name="department_id"
                          id="demo-simple-select-standard"
                          sx={{width:500}}
                          value={editableData.department_id}
                          onChange={(e) => handleChange(e, row.user_id)} // Specify 'designation' for clarity
                          label="department_id" // Optional label for accessibility
                        >
                                <option value="" disabled>
                    <em>Departments</em>
                  </option>
                  {departments.map(dept => (
                    <option key={dept.department_id} value={dept.department_id}>
                      {dept.department}
                    </option>
                  ))}
                        </Select>
                        </>
                      ) : (
                        departments.find((dept)=>dept.department_id === row.department_id)?.department
                      )}
                    </TableCell>
                    </>
                   )}
                    {value ===3 && (
                    <>
          <TableCell align="middle">
                      {isEditing && editRowId === index ? (
                        <>       
                        <Select
                          native
                          defaultValue={30}
                          name="complaint_type_id"
                          id="complaint-select"
                          sx={{width:500}}
                          value={editableData.complaint_type_id}
                          onChange={(e) => handleChange(e, row.user_id)} // Specify 'designation' for clarity
                          
                         >
                                <option value="" disabled>
                    <em>Complaint Types</em>
                  </option>
                  {complaintTypes.map(ct => (
                    <option key={ct.complaint_type_id} value={ct.complaint_type_id}>
                      {ct.complaint_type}
                    </option>
                  ))}
                        </Select>
                        </>
                      ) : (
                        complaintTypes.find((ct)=>ct.complaint_type_id === row.complaint_type_id)?.complaint_type
                      )}
                    </TableCell>

                    <TableCell align="middle">
                    {isEditing && editRowId === index ? (
            <TextField
              name="sub_complaint_type"
              id="sub_complaint_type"
              sx={{width:500}}
              value={editableData.sub_complaint_type}
              onChange={(e) => handleChange(e, row.complaint_type)}
            />
          ) : (
            row.sub_complaint_type
          )}
          </TableCell>
                    </>
                   )}
                   {value ===4 && (
                        <>
                              <TableCell align="middle">
                              {isEditing && editRowId === index ? (
                      <TextField
                        name="department"
                        id="department"
                        sx={{width:500}}
                        value={editableData.department}
                        onChange={(e) => handleChange(e, row.complaint_type)}
                      />
                    ) : (
                      row.department
                    )}
                    </TableCell>
                    </>
                   )}
                  </TableRow>
                );
              })
              
              }
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (35) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      {/* <Button
        variant="contained"
        color="primary"
        onClick={() => {
          if (data.length === 0) {
            alert('No data to export');
          }
          <ExportToExcel apiData={data} fileName={fileName}/>
        }}
        sx={{ mt: 2 }}
      >
        Export to Excel
            </Button> */}
      {/* JSX for the date selectors */}
      {data.length > 0 && <ExportToExcel apiData={data} fileName={fileName} />}
    </Box>
    </>

  );
}
export default AdminTable;
